# Activated by hover, focus, click, and/or touch
# Takes attributes for:
#   activation-type: String; 'hover', 'click', 'touch', 'focus' (Note: touch is added by default as it is the only way tooltips will work on mobile)
#   anchor: String (optional); text to be clicked on/hovered over to activate tooltip
#   icon-name: String (optional); hashtag-prefixed icon name from icon-map (e.g. '#icon-alert')
#   icon-position: String (optional; default: left); 'left' or 'right'
#   tooltip-id: String (skewer-case); used to link tooltip anchor with tooltip pane
#
# The content that is displayed when the tooltip is activated goes in between the open and close
# <amount-tooltip> tags.
#
# Ex:
#   <amount-tooltip
#     activation-type="hover focus touch"
#     anchor="Click me!"
#     icon-name="#icon-circle-exclamation"
#     icon-position="right"
#     tooltip-id="click-me-alert"
#   >
#     This is what pops up when you hover/click/touch/focus on the tooltip anchor.
#     It can include HTML <i>inline</i> elements (not block-level), other Angular directives, and Unicode 😃!
#     It gets transcluded into the `tooltip__pane` div in the directive template.
#   </amount-tooltip>
#
# NB: Directives (like <amount-icon>) can be used in tooltip content, however any other HTML elements
# must be inline elements (not block-level).
# For complete lists of block-level and inline elements, see:
#   * https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements#Elements
#   * https://developer.mozilla.org/en-US/docs/Web/HTML/Inline_elements#Elements

angular.module("avant.customer_applications.directives").directive "amountTooltip", () ->
  restrict: 'E'
  transclude: true
  scope:
    activation: '@activationType'
    anchor: '@'
    icon: '@iconName'
    position: '@iconPosition'
    ariaLabelledby: '@linkAriaLabelledby'
    tooltipId: '@'
    iconId: '@'
    neuroRegionQuestion: '@'
  # TODO: SSS switch <a> to <button> for accessibility
  template: '''
    <a
      class="tooltip"
      href="javascript:void(0);"
      aria-describedby="{{ tooltipId }}"
      aria-labelledby="{{ ariaLabelledby }}"
      ng-mouseenter="displayTooltip('hover');"
      ng-mouseleave="hideTooltip('hover');"
      ng-focus="displayTooltip('focus');"
      ng-blur="hideTooltip('focus');"
      ng-click="toggleTooltip('click');"
      ng-touch="toggleTooltip('touch');"
    ><amount-icon
        id="{{ iconId }}"
        ng-if="iconOnLeft"
        class="amount-icon"
        icon-name="{{ icon }}"
        aria-hidden="true"
      ></amount-icon>

      <span ng-if="hasAnchor">{{ anchor }}</span>

      <amount-icon
        id="{{ iconId }}"
        ng-if="iconOnRight"
        class="amount-icon"
        icon-name="{{ icon }}"
        aria-hidden="true"
      ></amount-icon>
    </a>

    <span
      id="{{ tooltipId }}"
      class="tooltip__pane"
      ng-class="{ 'tooltip__pane--open': isActivated }"
      role="tooltip"
      ng-transclude
    ></span>
  '''
  link: (scope, element, attrs) ->
    # neuro-region-question needs to be conditionally added to the element, otherwise if NeuroID is disabled
    # and the attribute is undefined NeuroID throws an error
    if !!attrs.neuroRegionQuestion then element.attr('neuro-region-question', attrs.neuroRegionQuestion)
    ## Display-condition helpers
    scope.isActivated = false
    scope.isFocused = false
    scope.activationArr = scope.activation.split(' ')
    unless scope.activationArr.includes('touch') then scope.activationArr.push('touch')

    scope.hasAnchor = scope.anchor?
    scope.hasIcon = scope.icon?
    scope.isValidPosition = scope.position? && scope.position in ['left', 'right']

    scope.position = if scope.hasIcon
      if scope.isValidPosition then scope.position else 'left'
    else
      null
    scope.iconOnLeft = scope.hasIcon && scope.position == 'left'
    scope.iconOnRight = scope.hasIcon && scope.position == 'right'

    scope.statusByType = {}
    scope.setAllStatusesTo = (bool) ->
      for el in scope.activationArr
        scope.setStatus el, bool
    scope.setStatus = (type, bool) ->
      scope.statusByType[type] = bool
    scope.toggleStatus = (type) ->
      scope.setStatus type, !scope.statusByType[type]

    ## Tooltip pane functionality
    scope.displayTooltip = (type) ->
      return unless type in scope.activationArr
      scope.isActivated = true
      scope.statusByType[type] = true

    scope.hideTooltip = (type) ->
      return unless type in scope.activationArr
      scope.isActivated = false
      scope.setAllStatusesTo false

    scope.toggleTooltip = (type) ->
      return unless type in scope.activationArr
      if scope.statusByType[type] == scope.isActivated
        fn = if scope.isActivated then scope.hideTooltip else scope.displayTooltip
        fn(type)
      else
        scope.toggleStatus type
